<template>
<div>
  <page-header :title="boardTitle" :description="getBoardDesc">
    <div class="btn-wrap" v-if="$store.state.login.userLevel == 4">
      <button class="btn btn-lg line-2" @click="create()" >작성
          <i class="icon-writing ml-5"></i>
      </button>
    </div>
  </page-header>
  <div class="page-body ph-30">
    <div class="sticky-holder">
      <div class="control-group space-between sticky">
        <div class="inner-wrap">
          <div class="btn-group m-r-xs">
            <!--button type="button" class="btn btn-md line-1" @click="create()"> 작성</button-->
            <button type="button" class="btn btn-md line-1" @click="edit()" :disabled="!isSingleChecked()" v-if="$store.state.login.userLevel == 4"> 수정</button>
            <!--button type="button" class="btn btn-md line-1" @delete="remove()"> 삭제</button-->
          </div>
        </div>
        <div class="inner-wrap">
          <div class="input-group align-top">
            <Dropdown :datasource="boardSearchDataSource" v-model="searchType" displayName="name" valueName="value" :isSelectionFirstData="true" :editMode="false" :isEdit="true" :isFieldMode="false"/>
            <input type="text" class="form-control" v-model="term">
            <button type="button" class="btn btn-m search" @click="searchClick()">
              <i class="icon-search"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <data-table :datasource="items" :noDataSpan="6">
      <template v-slot:header>
        <data-table-header-column name="checked" displayName="" width="50px">
          <!--<label class="md-check">-->
            <!--<input type="checkbox" @change="check" v-model="checkedAll">-->
            <!--<i class="blue"></i>-->
          <!--</label>-->
        </data-table-header-column>
        <data-table-header-column name="userName" displayName="번호" width="5%"/>
        <data-table-header-column name="empNumber" displayName="제목" width="50%"/>
        <data-table-header-column name="empMail" displayName="작성자" width="15%"/>
        <data-table-header-column name="memo" displayName="작성일" width="15%"/>
        <data-table-header-column name="memo" displayName="수정일" width="15%"/>
      </template>
      <template v-if="total != 0" v-for="(item, $index) in items">
        <tr v-bind:key="$index" @click="clickItem(item)">
          <td @click.stop>
            <div class="td-box" name="checked" width="50px">
              <span class="td-text ellipsis" data-original-title="">
                <label class="md-check" >
                <input type="checkbox" v-model="item.checked" @change="checkboxChange" >
                <i class="blue"></i>
              </label>
              </span>
            </div>
          </td>

          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="번호">{{$index + 1}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="" >
            <span class="td-text ellipsis" data-original-title="제목">{{item.title}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="작성자">{{item.createUser}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="작성일">{{getDate(item.createDate)}}</span>
          </data-table-column>
          <data-table-column name="checked" displayName="">
            <span class="td-text ellipsis" data-original-title="수정일">{{getDate(item.modifiedDate)}}</span>
          </data-table-column>
        </tr>
      </template>
    </data-table>
    <Pagenation ref="paging" :datasource="resultData" @pageChange="pageChange"/>
  </div>

</div>
</template>

<script>
import PageHeader from '@/layout/PageHeader.vue';
import DataTableBase from '@/components/common/dataTableBase';
import DataTable from '@/components/common/DataTable.vue';
import DataTableHeaderColumn from '@/components/common/DataTableHeaderColumn.vue';
import DataTableColumn from '@/components/common/DataTableColumn.vue';
import Pagenation from '@/components/common/Pagenation';
import Dropdown from '@/components/Dropdown.vue';
export default {
  mixins: [DataTableBase],
  components:{
    Pagenation,
    PageHeader,
    DataTable,
    DataTableHeaderColumn,
    DataTableColumn,
    Dropdown
  },
  props: ['boardTitle', 'boardName'],
  computed: {
    getBoardDesc(){
      return this.boardTitle + ' 목록입니다.';
    }
  },
  data(){

    return {
      term: '',
      searchType: 'title',
      getApi:'board',
      paging: this.$dataProvider.paging,
      boardSearchDataSource: this.$dataProvider.boardSearchDataSource,
      total: 0,
      resultData : null,
      //rowItem : {title: '공지사항', user: '강선호', createDate: '2021-07-07', modifiedDate: '2021-07-07'},
      //items: []
    }
  },
  mounted(){
    this.init();
  },
  methods: {
    init(){
      var query = Object.assign({},this.$route.query);
      debugger;
      this.paging = Object.assign(this.paging, {boardName : this.boardName});
      if(!query.limit || !query.offset){
        this.$router.push({ path: this.$route.path, query: this.paging});
        this.findAll();
      }else{
        this.findAll();
      }
    },
    pageChange(event){
      if(event)
        this.paging = event.data;

      var query = Object.assign({},this.$route.query);
      query.limit = this.paging.limit;
      query.offset = this.paging.offset;
      debugger;
      query.boardName = this.boardName;
      this.$router.push({ path: this.$route.path, query: query});

      this.findAll();
    },
    clickItem(item){
      /*

      if($(event.target).attr("type") == "checkbox" || $(event.target).hasClass('blue')){

        return;
      }else{
        this.$router.push({ path: '/app/notice/' + item.boardIndex, query: {mode: 'view'}, props: {item: item}})
      }
      */
      var query = Object.assign({},this.$route.query);
      query.mode = 'view';
      this.$router.push({ path: '/app/'+ this.boardName +'/' + item.boardIndex, query: query, props: {item: item}})
    },
    create(){
      var query = Object.assign({},this.$route.query);
      query.mode = 'new';
      this.$router.push({ path: '/app/'+ this.boardName +'/new', query: query})
    },
    edit(){
      var query = Object.assign({},this.$route.query);
      query.mode = 'edit';
      this.$router.push({ path: '/app/'+ this.boardName  +'/'+ this.selectedItems[0].boardIndex, query: query})
    },
    searchClick(){
      var query = Object.assign({},this.$route.query);
      // query.visitorName = this.term;
      query.term = this.term;
      query.searchType = this.searchType;
      query.offset = 1;
      this.$router.push({ path: '/app/'+ this.boardName  +'/', query: query})
      this.findAll();

    },
    remove(){

    },
    view(){

      var query = Object.assign({},this.$route.query);
      query.mode = 'view';
      this.$router.push({ path: '/app/'+ this.boardName  +'/', query: query})
      this.findAll();
    }
  }
}
</script>

<style>

</style>
